export default __webpack_public_path__ + "static/media/bookmark.e0ef7440.svg";